// extracted by extract-css-chunks-webpack-plugin
module.exports = {"switchLabel":"FavouriteControls__switchLabel--88AfT","deleteIcon":"FavouriteControls__deleteIcon--ma-qe","disabled":"FavouriteControls__disabled--tMXp8"};